import React from 'react';
import _findIndex from 'lodash/findIndex';
import classNameBind from 'classnames/bind';
import _isEqual from 'lodash/isEqual';
import Tooltip from '../Tooltip';
import Text from '../Text';
import StackGrid from '../StackGrid';
import styles from './TiledSelection.module.css';
import Tile from './components/Tile';

const bindClasses = classNameBind.bind(styles);

const TiledSelection = ({
  appearance,
  items,
  name,
  onChange,
  multi,
  value,
  emptySelectionText,
  dataId,
  fontSize,
  t,
} = {}) => {
  const isItemChecked = item => (
    multi
      ? value.some(selectedItem => _isEqual(selectedItem, item.value))
      : _isEqual(value, item.value)
  );

  const toggleChecked = (element) => {
    if (element.disabled === false) {
      let elements = multi ? [...value] : value;

      if (multi) {
        const index = _findIndex(value, item => (_isEqual(item, element.value)));

        if (index !== -1) {
          elements.splice(index, 1);
        } else {
          elements.push(element.value);
        }
      } else {
        elements = element.value;
      }

      onChange({
        target: {
          name,
          value: elements,
        },
      });
    }
  };

  if (items.length === 0) {
    return (
      <div
        className={bindClasses('empty')}
        data-ppuc-id={`${dataId}.empty`}
      >
        <Text type="subdued">
          {t(emptySelectionText)}
        </Text>
      </div>
    );
  }

  return (
    <div className={bindClasses('wrapper')}>
      <StackGrid
        dataId={dataId}
        spacingVertical="narrow"
        spacingHorizontal="narrow"
        itemMinWidth={appearance === 'wide' ? 191 : 120}
        itemMinHeight={appearance === 'wide' ? 120 : 160}
      >
        {items.map((item) => {
          const tile = (
            <Tile
              id={item.id}
              key={item.id}
              name={item.name}
              icon={item.icon}
              src={item.src}
              badge={item.badge}
              pending={item.pending}
              checked={isItemChecked(item)}
              disabled={item.disabled}
              wordBreakingStyle={item.wordBreakingStyle}
              onClick={() => { toggleChecked(item); }}
              multi={multi}
              dataId={dataId}
              fontSize={fontSize}
              wide={appearance === 'wide'}
            />
          );

          return item.tooltip
            ? (
              <Tooltip content={item.tooltip} key={item.value}>
                <div className={bindClasses('tooltip-wrapper')}>{tile}</div>
              </Tooltip>
            )
            : tile;
        })}
      </StackGrid>
    </div>
  );
};

TiledSelection.defaultProps = {
  onChange: () => {},
  value: [],
  multi: false,
  appearance: 'default',
  emptySelectionText: 'TiledSelection.no-items-available',
  dataId: 'TiledSelection',
  fontSize: 'default',
  t: () => {},
};

export { TiledSelection };
